import { HIDE_AKIT_ID } from '../constants';
import { useHideSomeExperiment } from './use-hide-some-experiment';

export const useHideAkit = () => {
  return useHideSomeExperiment(HIDE_AKIT_ID);
};
